import axios from 'axios';
import fileDownload from 'js-file-download';

const _downloadFile = async (url, filename) => {
  const result = await axios.get(url, { responseType: 'blob' });
  if (!result.data) {
    throw new Error('Cannot download file!');
  }
  fileDownload(result.data, filename);
};

const downloadFile = async (url, filename) => {
  const result = await fetch(url, { mode: "cors" });
  if (!result.ok) {
    throw new Error('Cannot download file!');
  }
  fileDownload(await result.blob(), filename);
};

export default downloadFile;
